var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ss-reach",attrs:{"title":_vm.title,"role":"img","aria-label":_vm.title}},[_c('i',{staticClass:"ss-reach__b",style:({ width: _vm.pct(_vm.before) })}),_c('i',{staticClass:"ss-reach__a",style:({ width: _vm.pct(_vm.after) })})])
}
var staticRenderFns = []

export { render, staticRenderFns }